<template>
  <div class="the-navbar__user-meta flex items-center" v-if="userData">

    <div class="text-right leading-tight sm:block">
      <p class="font-semibold" v-if="userData.name">{{ userData.name }} {{ userData.surname }}</p>
      <p class="font-semibold" v-else>{{ userData.email }}</p>
      <small v-if="userData.id_role < 40">{{ userData.name_role }}</small>
      <small v-else>¡Bienvenido!</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img v-if="userAvatar !== null" :src="getAvatar(userAvatar)" alt="" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
        <img v-else key="onlineImg" :src="activeUserInfo.avatar" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="toPerfil">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Mi Perfil</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="toCalendar" v-if="this.userRoles && this.userRoles.some(item => item.id_role < 40)">
            <feather-icon icon="CalendarIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Calendario</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="toMyAdvisor" v-if="this.userRoles && this.userRoles.some(item => item.id_role > 40)">
            <feather-icon icon="ShieldIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Mi Asesor</span>
          </li>

          <vs-divider class="m-1" />

        <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import axios from '@/axios.js'
export default {
  data () {
    return {
      userRoles: []
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    userData: {
      get () {
        return this.$store.state.user
      },
      set (val) {
        this.$store.state.user = val
      }
    },
    userAvatar: {
      get () {
        return this.$store.state.userAvatar
      },
      set (val) {
        this.$store.state.userAvatar = val
      }
    }
  },
  methods: {
    getAvatar (userAvatar) {
      return (axios.defaults.baseURLnoAPI) + userAvatar
    },
    toPerfil () {
      if (this.userData.client_id) return this.$router.push('/mi-perfil').catch(() => {})
      if (this.userData.employee_id) return this.$router.push('/perfilEmpleado').catch(() => {})
    },
    toMyAdvisor () {
      if (this.userData.client_id) return this.$router.push('/mi-asesor').catch(() => {})
    },
    toCalendar () {
      if (this.userData.client_id) return this.$router.push('/calendario').catch(() => {})
      if (this.userData.employee_id) return this.$router.push('/calendario').catch(() => {})
    },
    logout () {
      this.$store.dispatch('logout')
        .then(response => {
          if (response.data.status) {
            if (localStorage.getItem('userInfo')) {
              localStorage.removeItem('userInfo')
            }
            if (localStorage.getItem('userRoles')) {
              localStorage.removeItem('userRoles')
            }
            this.$acl.change('public')
            this.$router.push({ name:'login' }).catch(() => {})
            this.$vs.notify({
              title: 'Sesión finalizada',
              text: 'Has cerrado tu sesión exitosamente',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
              time: 6000
            })
          }
        })
        .catch(error => {
          
          if (error.response && error.response.data && (error.response.data.status === 401 || error.response.data.status === 403)) {
            if (localStorage.getItem('userInfo')) {
              localStorage.removeItem('userInfo')
            }
            if (localStorage.getItem('userRoles')) {
              localStorage.removeItem('userRoles')
            }
            this.$acl.change('public')
            this.$router.push({ name: 'login' }).catch(() => {})
          }


          this.$vs.notify({
            title: 'Error',
            text: `Usuario no autenticado - ${error}`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            time: 6000
          })
          console.error(error)
        })
    }
  },
  created () {
    this.userRoles = JSON.parse(localStorage.getItem('userRoles')) 
    this.$store.dispatch('fetchUserImageCorner')
      .catch(err => { 
        console.error(err)
        this.$vs.notify({
          title: 'Error',
          text:  `${err}`,
          color: 'danger',
          iconPack: 'feather',
          icon:'icon-alert-circle',
          time:6000
        })
      })

    this.$store.dispatch('fetchUserData')
      .catch(err => { 
        console.error(err)
        this.$vs.notify({
          title: 'Error',
          text:  `${err}`,
          color: 'danger',
          iconPack: 'feather',
          icon:'icon-alert-circle',
          time:6000
        })
      })
  }
}
</script>
